import { type FC, useState } from 'react';
import styled from 'styled-components';

import { ListAssetCategories } from '@/entities/assets/components/ListAssetCategories';
import { COLORS } from '@/shared/constants/colors';
import { routes } from '@/shared/helpers';
import { useAppRouter } from '@/shared/hooks/app/useAppRouter';
import { AssetCategory } from '@/shared/lib/sj-orm/models/asset.dto';
import { Button } from '@/shared/uikit/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { ModalSlideContainer } from '@/widgets/features/ModalSlideContainer';

import { useModalsStore } from '../..';
import { MobileSelectAssetCategoryModalProps } from '../../types';

export const MobileSelectAssetCategoryModal: FC<MobileSelectAssetCategoryModalProps> = ({
  onNext,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'mobileSelectAssetCategoryModal' });
  const modals = useModalsStore();
  const router = useAppRouter();
  const [selected, setSelected] = useState<AssetCategory | null>(null);

  const handleNext = async () => {
    if (!selected) return;

    modals.closeModal();
    if (onNext) {
      onNext(selected);
    } else {
      await router.pushShallow(routes.assetCreate(selected));
    }
  };

  return (
    <ModalSlideContainer
      title={t('title')}
      footer={null}
      open
      onCancel={modals.closeModal}
      drawerHeight="90vh"
      drawerStyles={{
        body: {
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <ListAssetCategories
        style={{
          width: '100%',
          maxHeight: '100%',
          paddingBlock: 24,
          marginTop: -12,
          marginBottom: -12,
          paddingInline: 16,
          gap: 16,
        }}
        onSelect={setSelected}
      />
      <Buttons>
        <Button type="default" style={{ height: 44 }} onClick={modals.closeModal}>
          {t('cancel')}
        </Button>
        <Button style={{ height: 44 }} disabled={!selected} onClick={handleNext}>
          {t('next')}
        </Button>
      </Buttons>
    </ModalSlideContainer>
  );
};

const Buttons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  padding-top: 12px;
  padding-bottom: 32px;
  padding-inline: 16px;
  gap: 12px;
  border-top: 1px solid ${COLORS.systemDark100};
  background: ${COLORS.systemLight100};
`;
